import { NotificationAction, NotificationSeverity } from "../enums";

export interface NotificationGetDto {
  action: NotificationAction;
  messageText: string;
  severity: NotificationSeverity;
}
